var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-guide-login-wrapper"},[_c('div',{staticClass:"guide-login-text-container"},[_vm._v("\n    Please log in.\n  ")])])
}]

export { render, staticRenderFns }